import { RoleTitles } from "views/settings-users/slices/users/constants";
import { ApplicationMergedActivity } from "../types";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { Link } from "react-router-dom";
import { DateTime } from "luxon";

interface ApplicationMergedProps {
  activityItem: ApplicationMergedActivity;
}

export const ApplicationMerged = ({ activityItem }: ApplicationMergedProps) => {
  if (
    typeof activityItem.details !== "object" ||
    !activityItem.details.merged_application_ids.length
  )
    return null;

  return (
    <div className="space-y-2">
      <p className="text-base font-bold text-content-1000">
        Applications were merged
      </p>
      <div>
        {activityItem.author?.name ? (
          <p className="text-sm font-normal text-content-400">
            by {activityItem.author.name} (
            {activityItem.author.author_role
              ? RoleTitles[activityItem.author.author_role]
              : "--"}
            )
          </p>
        ) : null}
        <p className="text-sm font-normal text-content-400">
          Merged at:{" "}
          {DateTime.fromISO(activityItem.details.merged_at).toFormat(
            "MMM d, yyyy 'at' h:mm a"
          )}
        </p>
        <p className="text-sm font-normal text-content-400">
          Merged applications:{" "}
          {activityItem.details.merged_application_ids.length}
        </p>
      </div>
      <div className="space-y-1">
        {activityItem.details.merged_application_ids.map((appId) => (
          <div key={appId}>
            <Link to={`/applications/${appId}`}>
              <Button variant={ButtonVariant.TEXT} size={ButtonSize.SM}>
                View application #{appId}
              </Button>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};
